import { initializeApp } from 'firebase/app';
import { getPerformance } from 'firebase/performance';

export let Performance = null;

export const initPerformance = () => {
  const app = initializeApp(process.env.FIREBASE_CONFIG);

  Performance = getPerformance(app);
};
